/* unplugin-vue-components disabled */import { render } from "./accuracyBarChart.vue?vue&type=template&id=27a73e6a"
import script from "./accuracyBarChart.vue?vue&type=script&lang=js"
export * from "./accuracyBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__